
import * as THREE from 'three'

function initParticleSystem() {
  var mParticleCount = 1000;
  var prefabGeometry = new THREE.SphereGeometry(12, 2, 2, 0, 1, 1, 0.5);
  var bufferGeometry = new THREE.BAS.PrefabBufferGeometry(prefabGeometry, mParticleCount);

  bufferGeometry.computeVertexNormals();

  // generate additional geometry data
  // used to calculate animation progress
  var aDelayDuration = bufferGeometry.createAttribute('aDelayDuration', 2);
  // used to calculate position on bezier curve
  // all start positions are (0,0,0), no need to fill that buffer, maybe remove it?
  var aStartPosition = bufferGeometry.createAttribute('aStartPosition', 3);
  var aControlPoint1 = bufferGeometry.createAttribute('aControlPoint1', 3);
  var aControlPoint2 = bufferGeometry.createAttribute('aControlPoint2', 3);
  var aEndPosition = bufferGeometry.createAttribute('aEndPosition', 3);
  // rotation
  var aAxisAngle = bufferGeometry.createAttribute('aAxisAngle', 4);
  // the 'color' attribute is used by three.js
  var aColor = bufferGeometry.createAttribute('color', 3);

  var i, j, offset;

  // buffer delay duration
  var delay;
  var duration;

  for (i = 0, offset = 0; i < mParticleCount; i++) {
    delay = THREE.Math.randFloat(0, 0.25);
    duration = THREE.Math.randFloat(3.5, 7.75);

    for (j = 0; j < prefabGeometry.vertices.length; j++) {
      aDelayDuration.array[offset++] = delay;
      aDelayDuration.array[offset++] = duration;
    }
  }

  // buffer control points
  var x, y, z;

  for (i = 0, offset = 0; i < mParticleCount; i++) {
    x = THREE.Math.randFloat(-100, 100);
    y = THREE.Math.randFloat(600, 1000);
    z = THREE.Math.randFloat(-100, 100);

    for (j = 0; j < prefabGeometry.vertices.length; j++) {
      aControlPoint1.array[offset++] = x;
      aControlPoint1.array[offset++] = y;
      aControlPoint1.array[offset++] = z;
    }
  }

  for (i = 0, offset = 0; i < mParticleCount; i++) {
    x = THREE.Math.randFloat(-600, 600);
    y = THREE.Math.randFloat(200, 1000);
    z = THREE.Math.randFloat(-600, 600);

    for (j = 0; j < prefabGeometry.vertices.length; j++) {
      aControlPoint2.array[offset++] = x;
      aControlPoint2.array[offset++] = y;
      aControlPoint2.array[offset++] = z;
    }
  }

  // buffer end positions

  for (i = 0, offset = 0; i < mParticleCount; i++) {
    x = 250 * Math.cos(i / mParticleCount * Math.PI * 2) + THREE.Math.randFloatSpread(500)
    y = 0;
    z = 250 * Math.sin(i / mParticleCount * Math.PI * 2) + THREE.Math.randFloatSpread(500)

    for (j = 0; j < prefabGeometry.vertices.length; j++) {
      aEndPosition.array[offset++] = x;
      aEndPosition.array[offset++] = y;
      aEndPosition.array[offset++] = z;
    }
  }

  // buffer start positions

  for (i = 0, offset = 0; i < mParticleCount; i++) {
    x = 25 * Math.cos(i / mParticleCount * Math.PI * 2) + THREE.Math.randFloatSpread(10)
    y = 0;
    z = 25 * Math.sin(i / mParticleCount * Math.PI * 2) + THREE.Math.randFloatSpread(10)


    for (j = 0; j < prefabGeometry.vertices.length; j++) {
      aStartPosition.array[offset++] = x;
      aStartPosition.array[offset++] = y;
      aStartPosition.array[offset++] = z;
    }
  }

  // buffer axis angle
  var axis = new THREE.Vector3();
  var angle = 0;

  for (i = 0, offset = 0; i < mParticleCount; i++) {
    axis.x = THREE.Math.randFloatSpread(2);
    axis.y = THREE.Math.randFloatSpread(2);
    axis.z = THREE.Math.randFloatSpread(2);
    axis.normalize();

    angle = Math.PI * THREE.Math.randInt(8, 16) + Math.PI * 0.5;

    for (j = 0; j < prefabGeometry.vertices.length; j++) {
      aAxisAngle.array[offset++] = axis.x;
      aAxisAngle.array[offset++] = axis.y;
      aAxisAngle.array[offset++] = axis.z;
      aAxisAngle.array[offset++] = angle;
    }
  }

  // buffer color
  var color = new THREE.Color();
  var h, s, l;

  for (i = 0, offset = 0; i < mParticleCount; i++) {
    // h = THREE.Math.randFloat(0.0, 1.0);
    // s = THREE.Math.randFloat(0.75, 1.0);
    l = THREE.Math.randFloat(0.1, 0.25);

    color.setHSL(0, 0, l);

    for (j = 0; j < prefabGeometry.vertices.length; j++) {
      aColor.array[offset++] = color.r;
      aColor.array[offset++] = color.g;
      aColor.array[offset++] = color.b;
    }
  }

  var material = new THREE.BAS.PhongAnimationMaterial(
    // custom parameters & THREE.MeshPhongMaterial parameters
    {
      vertexColors: THREE.VertexColors,
      shading: THREE.SmoothShading,
      side: THREE.DoubleSide,
      uniforms: {
        uTime: {
          type: 'f',
          value: 0
        }
      },
      shaderFunctions: [
        THREE.BAS.ShaderChunk['quaternion_rotation'],
        THREE.BAS.ShaderChunk['cubic_bezier'],
        THREE.BAS.ShaderChunk['ease_out_cubic']
      ],
      shaderParameters: [
        'uniform float uTime;',
        'attribute vec2 aDelayDuration;',
        'attribute vec3 aStartPosition;',
        'attribute vec3 aControlPoint1;',
        'attribute vec3 aControlPoint2;',
        'attribute vec3 aEndPosition;',
        'attribute vec4 aAxisAngle;'
      ],
      shaderVertexInit: [
        'float tDelay = aDelayDuration.x;',
        'float tDuration = aDelayDuration.y;',
        'float tTime = clamp(uTime - tDelay, 0.0, tDuration);',
        'float tProgress = ease(tTime, 0.0, 1.0, tDuration);',
        'float tScale = smoothstep(0.0, 1.0, 8.0 - abs(tProgress * 16.0 - 8.0));',

        'float angle = aAxisAngle.w * tProgress;',
        'vec4 tQuat = quatFromAxisAngle(aAxisAngle.xyz, angle);'
      ],
      shaderTransformNormal: [
        'objectNormal = rotateVector(tQuat, objectNormal);'
      ],
      shaderTransformPosition: [
        'transformed = rotateVector(tQuat, transformed);',
        'transformed *= tScale;',
        'transformed += cubicBezier(aStartPosition, aControlPoint1, aControlPoint2, aEndPosition, tProgress);'
      ]
    },
    // THREE.MeshPhongMaterial uniforms
    {
      shininess: 4
    }
  );

  const mParticleSystem = new THREE.Mesh(bufferGeometry, material);
  mParticleSystem.frustumCulled = false;
  return mParticleSystem;
}

export { initParticleSystem }